export const FULL_LENGTH_TESTS_TAB_PARAM = 'tab'

export enum FullLengthTestsTabs {
  FULL_LENGTH = 'Full-Length',
  MINI_LENGTH = 'Mini-Length',
}
